<template>
  <div class="home">
    <swiper ref="mySwiper" :options="swiperOptions" class="swiper-wrappe carousel">
      <swiper-slide class="swiper-slide">
        <div class="demo-carousel">
          <p>加入我们</p>
          <img src="@/assets/home/u1.png" alt />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <p>赛事通知</p>
        <img src="@/assets/home/u2.png" alt />
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <p>营地魅力</p>
        <img src="@/assets/home/u3.png" alt />
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <p>编程一小时</p>
        <img src="@/assets/home/u4.png" alt />
      </swiper-slide>
      <!-- 分页器 -->
      <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
      <!-- 左右箭头 -->
      <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
    </swiper>
    <div class="wave">
      <img src="@/assets/home/wave.png" alt />
    </div>
    <div class="part">
      <div class="wd">
        <p>
          <span style="font-weight:700;">少儿编程：</span>
          <span>做最有趣的编程社区</span>
        </p>
        <p class="tip">仅使用电脑和开发板带孩子学编程</p>
        <Row class="course">
          <i-col span="8">
            <img width="319" src="@/assets/home/course1.png" alt />
            <Button class="know" style="left: 50%" type="warning">
              <router-link to="/community">了解更多</router-link>
            </Button>
          </i-col>
          <i-col span="8">
            <img width="319" src="@/assets/home/course2.png" alt />
            <Button class="know" style="top: 271px;" type="warning">
              <router-link to="/community">了解更多</router-link>
            </Button>
          </i-col>
          <i-col span="8">
            <img width="319" src="@/assets/home/course3.png" alt />
            <Button class="know" type="warning">
              <router-link to="/community">了解更多</router-link>
            </Button>
          </i-col>
        </Row>
        <Row class="play-area" type="flex" align="middle" justify="space-around">
          <i-col span="16">
            <Row type="flex" align="middle">
              <i-col span="6">
                <svg-icon class="hover-img" icon-class="play"></svg-icon>
                <p class="item-title">组队闯关</p>
              </i-col>
              <i-col span="6">
                <img class="hover-img" src="@/assets/home/world.png" alt />
                <p class="item-title">我的世界</p>
              </i-col>
              <i-col span="6">
                <svg-icon class="hover-img" icon-class="tools"></svg-icon>
                <p class="item-title">参加竞赛</p>
              </i-col>
              <i-col span="6">
                <img class="hover-img" src="@/assets/home/yd.png" alt />
                <p class="item-title">和好友一起来营地</p>
              </i-col>
              <i-col span="6">
                <img class="hover-img" src="@/assets/home/games.png" alt />
                <p class="item-title">创作游戏</p>
              </i-col>
              <i-col span="6">
                <svg-icon class="hover-img" icon-class="app"></svg-icon>
                <p class="item-title">创作App</p>
              </i-col>
              <i-col span="6">
                <svg-icon class="hover-img" icon-class="web"></svg-icon>
                <p class="item-title">搭建网站</p>
              </i-col>
              <i-col span="6">
                <svg-icon class="hover-img" icon-class="code"></svg-icon>
                <p class="item-title">学习最流行编程</p>
              </i-col>
            </Row>
          </i-col>
          <i-col span="6" class="word">
            <p class="area-title">少儿编程Scratch编程平台：</p>
            <p>
              以丰富有趣的方式为孩子提供了学习<span>计算机编程</span>所需的一切。推动了大量孩子的<span>创造力</span>，赋予孩子有关未来的<span>无限可能</span>。
              以有趣的方式提供了学习
            </p>
            <p>
              凭借<span>50多个</span>在名校磨炼多次的课程，超过<span>500个</span>学习模块，囊括多种流行编码语言，为不同年龄和水平的孩子提供一条<span>高效学习编程的道路</span>。
            </p>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="part1">
      <div class="wd">
        <p>
          <span>我们有最丰富的作品社区</span>
        </p>
        <p class="tip" style="font-size: 16px;">积木编码，python，网站开发等3000多个积木！</p>
        <Row type="flex" align="middle" justify="center">
          <i-col span="3">
            <Button
              :class="'btn ' + (type === 'preWeek' ? 'active' : '')"
              size="large"
              shape="circle"
              @click="getWorkRank('preWeek','star')"
            >上周最佳</Button>
          </i-col>
          <i-col span="3">
            <Button
              size="large"
              shape="circle"
              :class="'btn ' + (type === 'time' ? 'active' : '')"
              @click="getWorkRank('','time')"
            >最新热门</Button>
          </i-col>
          <i-col span="3">
            <Button
              size="large"
              shape="circle"
              :class="'btn ' + (type === 'star' ? 'active' : '')"
              @click="getWorkRank('','star')"
            >评价最高</Button>
          </i-col>
        </Row>
        <Row type="flex" style="margin-top: 20px">
          <i-col
            span="4"
            class="card-list"
            v-for="(item, index) in workRankResult.records"
            :key="index"
          >
            <Card :shadow="true" class="card">
              <div class="pic" @click="toDetail(item.id)">
                <img :src="item.coverFileUrl" alt />
              </div>
              <div class="content">
                <p class="title" @click="toDetail(item.id)">{{ item.workName }}</p>
                <Row type="flex" justify="space-between">
                  <i-col span="8">初学者</i-col>
                  <i-col span="8">{{ item.workType_dictText }}</i-col>
                </Row>

                <Icon class="vm" type="md-thumbs-up" size="22" color="#d9d9d9" />
                <span class="vm" style="font-size: 13px; margin-right: 19px">
                  {{
                  item.starNum
                  }}
                </span>
                <Icon class="vm" type="md-eye" size="23" color="#d9d9d9" />
                <span class="vm" style="font-size: 13px">
                  {{
                  item.viewNum
                  }}
                </span>
              </div>
              <Row type="flex" align="middle" justify="space-between" class="footer">
                <i-col span="16">
                  <svg-icon
                    class="vm"
                    style="font-size: 30px"
                    icon-class="user"
                    @click="toFriend(item.userId)"
                  ></svg-icon>
                  <span class="vm" @click="toFriend(item.userId)">
                    {{
                    item.realname
                    }}
                  </span>
                </i-col>
                <i-col span="6">一周前</i-col>
              </Row>
            </Card>
          </i-col>
        </Row>
        <Button class="know community" style="left: 50%" type="warning">
          <router-link to="/community">进入社区</router-link>
        </Button>
      </div>
    </div>
    <!-- <div>
      <p>
        <span>赛事安排</span>
      </p>
    </div>-->
    <div class="part3">
      <p>
        <span>受到多所名校的信赖</span>
      </p>
      <div class="school">
        <img src="@/assets/home/x1.png" alt />
        <img src="@/assets/home/x2.png" alt />
        <img src="@/assets/home/x3.png" alt />
        <img src="@/assets/home/x4.jpg" alt />
        <img src="@/assets/home/x1.png" alt />
      </div>
      <div class="wd word">
        <Row type="flex">
          <i-col span="7">
            <img src="@/assets/home/ss1.png" alt />
          </i-col>
          <i-col span="8">
            <img src="@/assets/home/ss2.png" alt />
          </i-col>
          <i-col span="7">
            <img src="@/assets/home/ss3.png" alt />
          </i-col>
        </Row>
      </div>
      <div class="music">
        <Row type="flex" align="middle" justify="center" class="code-row-bg">
          <i-col span="2">
            <img src="@/assets/home/s2.png" alt />
          </i-col>

          <i-col span="9">
            <svg-icon icon-class="s3" style=" font-size: 26px;"></svg-icon>
            <span class="search">找出为什么大家都喜欢</span>
            <span class="name">少儿编程</span>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="part4">
      <div class="wd">
        <p>
          加入
          <span style="font-weight:700;">少儿编程</span>全球社区
        </p>
        <Button type="primary">
          <router-link to="/register">免费注册</router-link>
        </Button>
        <img class="map" src="@/assets/home/map.png" alt />
      </div>
    </div>
  </div>
</template>
<script>
import { getWorkRank } from "@/api/community";
export default {
  data() {
    return {
      type: "star",
      list: [{}, {}, {}, {}, {}],
      workRankResult: {},
      swiperOptions: {
        speed:800,
        effect: "fade",
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {
    this.getWorkRank("", "star");
  },
  methods: {
    //作品排行榜 cycle:perWeek|star|year
    getWorkRank(cycle, orderBy) {
      this.type = cycle;
      getWorkRank(cycle,orderBy, 1, 5).then((res) => {
        console.log(res);
        if (res.success) {
          this.workRankResult = res.result;
        }
      });
    },
    toDetail(workId) {
      this.$router.push({
        path: `/task-detail?workId=${workId}`,
      });
    },
    toFriend(userId) {
      this.$router.push({
        path: `/friends?userId=${userId}`,
      });
    },
  },
};
</script>
<style lang="scss">
.home {
  .carousel {
    .ivu-carousel-dots {
      display: block;
      position: absolute;
      bottom: 88px;
      padding-right: 20px;
      .ivu-carousel-active button {
        background: #fff;
      }
      button {
        width: 10px;
        height: 10px;
        border: 2px solid #fff;
        background: unset;
        border-radius: 50%;
        opacity: 1;
        margin-right: 8px;
      }
    }
    .ivu-carousel-arrow {
      background: unset;
      .ivu-icon {
        font-size: 54px;
        opacity: 0.6;
      }
    }
  }
  .part .ivu-row-flex-middle {
    height: 400px;
  }
}
</style>
<style lang="scss" scoped>
.home {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
  color: rgb(51, 51, 51);
  font-size: 36px;
  .carousel {
    font-size: 0;
    height: 751px;
    margin-top: -80px;
    padding-top: 80px;
    background: linear-gradient(
      180deg,
      rgba(111, 134, 214, 1) 7%,
      rgba(77, 188, 235, 1) 100%
    );
    .swiper-slide {
      background-position: center;
      background-size: cover;
    }
    img {
      width: 1200px;
      height: 614px;
    }
    p {
      background: rgba(91, 34, 161, 1);
      font-size: 20px;
      font-weight: 700;
      color: #fff;
      line-height: 56px;
    }
  }
  .wave {
    z-index: 999;
    position: relative;
    img {
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
    }
  }
  .tip {
    margin-top: 20px;
    font-size: 20px;
  }
  .part {
    background: #fff;
    margin-top: -1px;
    .course {
      margin-top: 80px;
      position: relative;
      .know {
        position: absolute;
        left: 51%;
        top: 275px;
        transform: translateX(-50%);
        width: 140px;
        height: 40px;
      }
    }
    .play-area {
      margin-top: 60px;
      font-size: 0;
      height: 432px;
      .item-title {
        color: #333;
        font-size: 20px;
        font-weight: bold;
        margin-top: 10px;
      }
      .word {
        font-family: "微软雅黑", sans-serif;
        font-size: 18px;
        text-align: left;
        p {
          margin-bottom: 20px;
        }
        .area-title {
          font-size: 28px;
          margin-bottom: 30px;
        }
        span {
          font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑",
            sans-serif;
          font-weight: 700;
        }
      }
      .hover-img {
        font-size: 128px;
        margin-right: 10px;
        transition: all 0.2s ease-out;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
  .part1 {
    margin-top: 40px;
    .tip {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .btn {
      font-size: 16px;
      padding: 0 28px;
      color: #575757;
      background-color: rgba(228, 228, 228, 1);
      border: none;
      &:hover {
        color: rgb(0, 188, 212);
      }
      &.active {
        background-color: rgba(13, 135, 199, 1);
        color: #fff;
      }
    }
    .card-list {
      margin-right: 52px;
      margin-bottom: 20px;
      &:last-child {
        margin-right: 0;
      }
      .card {
        width: 210px;
        text-align: left;
        color: #999;
        .pic {
          width: 100%;
          height: 185px;
          overflow: hidden;
          img {
            width: 100%;
            height: 185px;
            transition: all 0.2s ease-out;
            &:hover {
              transform: scale(1.05);
            }
          }
        }
        .content {
          padding: 8px 20px;

          border-bottom: 1px solid #e8e8e8;
          .title {
            color: #666;
            font-size: 16px;
            font-weight: bold;
          }
        }
        .footer {
          padding: 4px 20px;
        }
      }
    }
  }
  .community {
    margin: 40px 0 80px 0;
  }
  .part3 {
    font-size: 0;
    background: url("../../assets/home/s1bg.png") #d5f3fc no-repeat;
    background-size: 100% 532px;
    p {
      font-size: 36px;
    }
    .school {
      margin-top: 120px;
      img {
        height: 160px;
        margin-right: 30px;
      }
    }
    .music {
      padding: 8px 0;
      background-color: rgba(237, 252, 255, 1);
      box-shadow: 5px 2px 10px rgba(0, 0, 0, 0.34);
      img {
        width: 132px;
      }
      span {
        font-size: 20px;
        &.name {
          color: rgb(8, 190, 214);
        }
        &.search {
          margin: 0 10px;
          &:hover {
            color: rgb(0, 143, 161);
          }
        }
      }
    }
    .word {
      margin-top: 160px;
      padding-bottom: 90px;
      img{
          width: 98%;
        }
    }
  }
  .part4 {
    margin: 100px 0 30px 0;
    button {
      background: rgba(245, 154, 35, 1);
      border-color: rgba(245, 154, 35, 1);
      font-size: 16px;
      height: 40px;
    }
    .map {
      margin-top: 30px;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue